import {
  applyToRequest,
  fetchToken,
  initAntibot,
  injectIntoForm,
} from "@lib/antibot";

initAntibot();

window.antibotTokenClient = { fetchToken, injectIntoForm, applyToRequest };
